module.exports = __webpack_public_path__ + "static/media/ai.35544f35.png";